import { render, staticRenderFns } from "./NormalDialog.vue?vue&type=template&id=6186e2b6&scoped=true&"
import script from "./NormalDialog.vue?vue&type=script&lang=ts&"
export * from "./NormalDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NormalDialog.vue?vue&type=style&index=0&id=6186e2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186e2b6",
  null
  
)

export default component.exports